var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33199 10C0.959789 10 0.644738 9.88333 0.386843 9.65C0.128948 9.41667 0 9.13162 0 8.79486V1.20514C0 0.868381 0.128948 0.583335 0.386843 0.350001C0.644738 0.116667 0.959789 0 1.33199 0H12.668C13.0402 0 13.3553 0.116667 13.6132 0.350001C13.8711 0.583335 14 0.868381 14 1.20514V8.79486C14 9.13162 13.8711 9.41667 13.6132 9.65C13.3553 9.88333 13.0402 10 12.668 10H1.33199ZM7 5.37177L1.10525 1.96151V8.79486C1.10525 8.8547 1.12651 8.90385 1.16902 8.94231C1.21154 8.98078 1.26586 9.00001 1.33199 9.00001H12.668C12.7341 9.00001 12.7885 8.98078 12.831 8.94231C12.8735 8.90385 12.8948 8.8547 12.8948 8.79486V1.96151L7 5.37177ZM7 4.33333L12.7814 0.999987H1.21861L7 4.33333ZM1.10525 1.96151V0.999987V8.79486C1.10525 8.8547 1.12651 8.90385 1.16902 8.94231C1.21154 8.98078 1.26586 9.00001 1.33199 9.00001H1.10525V1.96151Z",
    fill: "#064765"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.3c90db9f108e4e9fde7e303edebd473e.svg";
export { ForwardRef as ReactComponent };